/**
 * Redux Form Validations
 */

import { each, get, set, size } from 'lodash';
import { SubmissionError } from 'redux-form';

export function validateFields(
  fields, validations: IFormValidations, validationArguments: { [validatorName: string]: any[] } = {}) {
  return new Promise((resolve, reject) => {
    const errors = {};

    each(validations, ({ error, validator, validatorRequiresArguments }, key) => {
      const value = get(fields, key, '');
      if (value) {
        if (validator) {
          if (validatorRequiresArguments) {
            if (validationArguments.hasOwnProperty(validator.name)) {
              if (!validator(value, ...validationArguments[validator.name])) {
                set(errors, key, error);
              }
            }
          } else if (!validator(value)) {
            set(errors, key, error);
          }
        }
      } else {
        set(errors, key, error);
      }
    });

    if (size(errors)) {
      reject(new SubmissionError(errors));
    } else {
      resolve();
    }
  });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/form/validation.ts